import React from "react"

import {
  darken,
  styled,
  Tooltip,
  Typography,
  useTheme
} from "@mui/material"

import { ChevronRightRounded, LockRounded, OpenInNewRounded } from "@mui/icons-material"

import HKVLink from "../HKVLink"

const List = (props) => {
  const {
    bordered = false,
    items = [],
    title,
    titleVariant = "h2",
    variant
  } = props

  const theme = useTheme()

  const StyledListItem = styled("li", {
  })(({ theme, variant, bordered }) => {
    const style = {
      yellow: {
        background: theme.palette.geel.main
      },
      blue: {
        background: theme.palette.lichtblauw.light
      },
      white: {
        background: "white"
      }
    }

    return {
      background: style[variant]?.background || theme.palette.grey[100],
      borderRadius: bordered ? 0 : theme.shape.borderRadius,
      marginBottom: theme.spacing(0.75),
      borderBottom: "1px solid",
      borderTop: "1px solid",
      borderColor: bordered ? theme.palette.grey[300] : "transparent",
      padding: 0,
      listStyle: "none",
      "& .favorite:last-of-type": {
        marginBottom: theme.spacing(1)
      }
    }
  })

  const StyledLink = styled(HKVLink, {
  })(({ theme, variant }) => {
    const style = {
      yellow: {
        color: theme.palette.text.primary
      },
      blue: {
        color: theme.palette.text.primary
      },
      white: {
        color: theme.palette.hemelblauw.main
      }
    }

    return {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      padding: theme.spacing(1, 1.5),
      boxSizing: "border-box",
      textDecoration: "none",
      color: style[variant]?.color || theme.palette.hemelblauw.main,
      "&:hover": {
        color: darken(style[variant]?.color || theme.palette.lintblauw.main, 0.1),
        textDecoration: "underline"
      }
    }
  })

  return (
    <section>
      {title && <div className="section-head">
        <Typography variant={titleVariant} color="lintblauw">{title}</Typography>
      </div>}
      <div className="section-body">
        {items?.length > 0 && <ul style={{ marginLeft: 0, paddingLeft: 0 }}>
          {items.map((item, ix) => {
            const isFavorite = item.favorite
            const isPublic = item.public
            const isLastFavorite = isFavorite && items.slice(ix + 1).find((nextItem) => nextItem.favorite) === undefined

            return (
              <StyledListItem
                key={ix}
                variant={variant}
                bordered={bordered}
                sx={isLastFavorite ? { marginBottom: theme.spacing(1.5) } : {}}
              >
                <StyledLink
                  className="transition"
                  to={item.link}
                  variant={variant}
                >
                  <Typography component="span" sx={{ display: "flex", alignItems: "center" }}>
                    {isFavorite ? <Tooltip title="Opent in een nieuw tabblad"><OpenInNewRounded color="lintblauw" fontSize="small" sx={{ marginRight: theme.spacing(0.75) }} /></Tooltip> : null}
                    {isPublic === false ? <Tooltip title="Je hebt inloggegevens nodig om deze pagina te bekijken.">
                      <LockRounded color="lintblauw" fontSize="small" sx={{ marginRight: theme.spacing(0.75) }} />
                    </Tooltip> : null}
                    {item.name}
                  </Typography>
                  <ChevronRightRounded />
                </StyledLink>
              </StyledListItem>
            )
          })}
        </ul>}
      </div>
    </section>
  )
}

export default React.memo(List)